import React, {forwardRef, useEffect, useState} from "react";
import {
    decodeDeeplink, formatDateCharDesc, formatDateHms,
    getImagePath,
    getImagePathWithTheme,
    getImagePathWithThemeSvg, isArray,
    isDeepLink,
    isNumberOrFloat, isObject
} from "../../utils";
import {
    deepLinkToLinkInfo,
    getCardTitle,
    getImageNameFromdeepLinkType,
    getLibraryTypeImage,
    isSupportLink
} from "../../Utility";
import CustomDeeplink from "./CustomDeeplink";
import {
    DEFAULT_CONTENT_MIN_HEIGHT,
    EVENT_OPEN_LIBRARY_ITEM,
    EVENT_SHOW_DIALOG_DRAWINDEX, FROM_HOME_HIGHLIGHT,
    FROM_LIBRARY,
    FROM_TAG, FROM_TRASH, GET_ARRAY_LIBRARY_TYPES, MAP_WEEK_FULL,
    MAX_Z_INDEX
} from "@/Const";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {updateProperty} from "@model/Property";
import {Checkbox, Popover, message,Tooltip } from "antd";
import { t } from "i18next";
import {postMessage} from "@/common/event";
import CustomPropertySelect from "./CustomPropertySelect";
import PopupDate from "./PopupDate";
import CustomPropertyTags from "@/views/Property/CustomPropertyTags";
import {updateBoard} from "@model/board";
import {updateCard} from "@model/card";
import {updateProject} from "@model/note";
import './GridViewPropertyInfo.css'
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";

const GridViewPropertyInfo = forwardRef((props:{tableView:any,item:any,from:any},ref)=>{

    const [data,setData] = useState(props.item);
    const [openDatePicker,setOpenDatePicker] = useState<any>({});
    const [inputDate,setInputDate] = useState('');
    const [mapTextAreaStatus,setMapTextAreaState] = useState<any>({});
    const [mapTextAreaIsEditable,setMapTextAreaIsEditable] = useState<any>({});
    const [mapTooltipsOpen,setMapTooltipsOpen] = useState<any>({});

    useEffect(() => {
        setData(props.item);
        setMapTooltipsOpen({});
    }, [props.item]);

    const calcPropertyInfoTextHeight = (key)=>{
        const textArea = document.createElement('textarea');
        const txt = document.getElementById(`txtarea-info-property-${key}`);
        if (!txt)return 30;
        textArea.id = 'txt-test-ssss-cr-h';
        textArea.classList.add('textarea-style-focus-border');
        textArea.style.width = (txt.offsetWidth || 322)+'px';
        textArea.style.fontSize = txt.style.fontSize;
        textArea.style.fontFamily = txt.style.fontFamily;
        if (key == 'infoNotes' || key == 'infoUrl'){
            textArea.innerHTML = data[key];
        }else{
            textArea.innerHTML = data[key].text;
        }

        textArea.style.position = 'fixed';
        textArea.style.zIndex = '999990';
        textArea.style.left = '0';
        textArea.style.top = '40px';
        textArea.style.paddingLeft = txt.style.paddingLeft;
        textArea.style.paddingRight = txt.style.paddingRight;
        textArea.style.paddingTop = txt.style.paddingTop;
        textArea.style.paddingBottom = txt.style.paddingBottom;
        textArea.style.resize = 'none';

        // textArea.style.overflowWrap ='anywhere';
        textArea.style.background = '#ff000000';
        // textArea.style.whiteSpace = 'pre';

        document.body.appendChild(textArea);

        textArea.style.height = '0px';
        // textArea.style.height = textArea.scrollHeight + 'px';
        let nHeight = textArea.scrollHeight;
        textArea.style.height = nHeight + 'px'
        document.body.removeChild(textArea);
        if (nHeight < 30){
            nHeight = 30;
        }
        return nHeight + 10;
    }

    const isDeeplinkAndNoEdit = (key)=>{
        let szText = data[key];
        if (isObject(data[key])){
            szText = data[key]?.text
        }
        let isDeeplink = isDeepLink(szText)
        return isDeeplink && !mapTextAreaIsEditable[key];
    }

    const updateProperty = (newData:any,key)=>{
        props.item[key] = newData[key];

        if (data.type == 'board'){
            updateBoard(newData).then(res=>{
                if (window.refresh_tableview_){
                    window.refresh_tableview_();
                }else{
                    window.globalRefreshList('refresh_gridview_')
                }
            })
        }
        else if (data.type && data.type != 'project'){
            updateCard(newData).then(res=>{
                if (window.refresh_tableview_){
                    window.refresh_tableview_();
                }else{
                    window.globalRefreshList('refresh_gridview_')
                }
            });
        }else{
            updateProject(newData).then(res=>{
                if (window.refresh_tableview_){
                    window.refresh_tableview_();
                }else{
                    window.globalRefreshList('refresh_gridview_')
                }
            });
        }
    }

    /**
     * 这里是内容...
     * @param key
     */
    const renderContent = (column)=>{
        const key = column.id;
        const getBackgroundByStatus = ()=>{
            const szStatus = mapTextAreaStatus[key];
            if (!szStatus){
                return 'transparent';
            }
            if (szStatus == 'focus' || szStatus == 'blur' || szStatus == 'mouseLeave'){
                return 'transparent'
            }
            return 'var(--property-info-item-hover-color)';
        }

        const getTextAreaBackgroundByStatus = ()=>{
            const szStatus = mapTextAreaStatus[key];
            if (!szStatus){
                return 'transparent';
            }
            if (mapTextAreaIsEditable[key]){
                return 'var(--background-color)';
            }
            return 'transparent'
        }

        /**
         * 输入的值，有混合着另外2个很早之前的属性....
         */
        const getInputTextValue = ()=>{
            if (key == 'infoNotes' || key == 'infoUrl'){
                return data[key];
            }
            return data[key].text || '';
        }

        /**
         * 是否应该显示链接
         */
        const shouldShowLinkImage = ()=>{
            if (value?.type == 'url'){
                return data[key].text;
            }else if (key == 'infoUrl'){
                return data[key];
            }
            return false;
        }

        const value = data[key];
        if (!value && column.type != 'checkbox' && column.type !='rating')return <></>
        if (value?.type == 'text' || value?.type == 'url' || value?.type == 'number' || key == 'infoNotes' || key == 'infoUrl'){
            //region text
            let szText = data[key];
            if (isObject(data[key])){
                szText = data[key].text;
            }
            if (!szText)return <></>
            return <div className={''} style={{
                position: 'relative',
                width: '100%',
                marginTop: '0px',
                minHeight: `${DEFAULT_CONTENT_MIN_HEIGHT}px`,
                display:'flex',
                borderRadius:'8px',
                background: getBackgroundByStatus(),
                height: mapTextAreaIsEditable[key] ? 'auto' : `${/*calcPropertyInfoTextHeight(key) + 0*/30}px`,
                maxHeight: '130px'
            }}onClick={(e)=>{
                e.stopPropagation();
            }}>
                <textarea id={`txtarea-info-property-${key}`}
                          className={`${mapTextAreaIsEditable[key] ? 'textarea-editable' : 'text-truncate-1'} ${mapTextAreaStatus[key] != 'focus' ? 'text-truncate-7' : ''}  textarea-style-focus-border ` + ((shouldShowLinkImage()) ? 'url-link' : '')}
                          style={{
                              resize: 'none',
                              width: '100%',
                              display: isDeeplinkAndNoEdit(key) ? 'none' : '',
                              overflowY: (mapTextAreaStatus[key] == 'focus' ) ? 'auto' : 'hidden',
                              height: `${mapTextAreaIsEditable[key] ? calcPropertyInfoTextHeight(key) : 24}px`,
                              background:getTextAreaBackgroundByStatus(),
                              maxHeight: '130px',
                              paddingTop: '6px',
                              margin: '2px 0 0 0',
                              // zIndex:'9999999'
                          }}
                          value={getInputTextValue()} placeholder={t("Empty")} onChange={(e) => {
                    const szValue = e.currentTarget.value;
                    if (data[key].type == 'number') {
                        if (szValue && !isNumberOrFloat(szValue)) {
                            return;
                        }
                    }
                    const newData = {...data};
                    if (key == 'infoNotes' || key == 'infoUrl') {
                        newData[key] = e.currentTarget.value;
                    }else {
                        newData[key].text = e.currentTarget.value;
                    }
                    setData(newData);
                    if (!e.currentTarget.value) {
                        //没有数据了，这里要更新一下.
                        updateProperty(newData, key);
                    }
                }} onFocus={(e) => {
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'focus';
                    setMapTextAreaState(newMap);

                    const newMap0 = {...mapTextAreaIsEditable};
                    newMap0[key] = true;
                    setMapTextAreaIsEditable(newMap0);

                    if (isDeepLink(data[key].text)) {
                        const nLen = e.currentTarget.value.length;
                        e.currentTarget.setSelectionRange(nLen,nLen);
                        e.currentTarget.scrollTop = e.currentTarget.offsetHeight;
                    }
                }} onMouseEnter={(e) => {
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'mouseEnter';
                    setMapTextAreaState(newMap);
                }} onMouseLeave={(e) => {
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'mouseLeave';
                    setMapTextAreaState(newMap);
                }} onBlur={(e) => {
                    e.currentTarget.scrollTop = 0;
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'blur';
                    setMapTextAreaState(newMap);

                    const newMap0 = {...mapTextAreaIsEditable};
                    newMap0[key] = false;
                    setMapTextAreaIsEditable(newMap0);

                    const newData = {...data};
                    if (key == 'infoNotes' || key == 'infoUrl') {
                        newData[key] = e.currentTarget.value;
                    }else {
                        newData[key].text = e.currentTarget.value;
                    }
                    updateProperty(newData, key);
                }} onKeyDown={(e)=>{
                    if (e.key == KEYS.ENTER){//哪里会处理这个enter ?????????????????????????????????????????? 找不到...
                        if (e.ctrlKey || e.metaKey){
                            console.log('e.shiftkey*****')
                            let szTxt = e.currentTarget.value;
                            szTxt = szTxt + '\r\n';

                            const newData = {...data};
                            if (key == 'infoNotes' || key == 'infoUrl') {
                                newData[key] = szTxt;
                            }else {
                                newData[key].text = szTxt;
                            }

                            e.stopPropagation();
                        }else if (e.shiftKey){
                            e.stopPropagation();
                        }
                        else{
                            e.currentTarget.blur();
                        }
                    }
                    else if (e.key == KEYS.ESCAPE) {
                        e.currentTarget.blur();
                    }
                }}>
            </textarea>
                {
                    (value.type == 'url' || key == 'infoUrl') && <>
                        {
                            (isDeeplinkAndNoEdit(key)) ? <div className={'flex-row-vertical-center'}
                                                              style={{
                                                                  position: 'absolute',
                                                                  top: '8px',
                                                                  left: '7px',
                                                                  cursor: 'pointer',
                                                                  opacity: '1',
                                                                  marginRight: '16px',
                                                                  width:'calc(100% - 40px)'
                                                              }}>
                                    <CustomDeeplink url={data[key].text} onItemClick={() => {
                                        const newMap = {...mapTextAreaIsEditable};
                                        newMap[key] = true;
                                        setMapTextAreaIsEditable(newMap);

                                        setTimeout(() => {
                                            const input = document.getElementById(`txtarea-info-property-${key}`);
                                            if (input) {
                                                input.setSelectionRange(0, 0);
                                                input.focus();
                                            }
                                        }, 100)
                                    }}/></div> :
                                <span className={'span-single-line'} style={{
                                    position: 'absolute',
                                    top: '6px',
                                    left: '7px',
                                    cursor: 'pointer',
                                    opacity: '0',
                                    display: mapTextAreaIsEditable[key] ? 'none' : 'none'
                                }}
                                      onClick={(e) => {
                                          let szUrl = data[key].text;
                                          if (!szUrl.startsWith('http')) {
                                              szUrl = 'https://' + szUrl;
                                          }
                                          //打开链接
                                          ipcInvoke('open-url-withwhen', szUrl).then(res => {
                                              if (res == 'error') {
                                                  message.error(t("Open error"));
                                              }
                                          })
                                      }}>{data[key].text}</span>
                        }
                    </>
                    // !data[key].text && <span style={{position:'absolute'}}>{t("Empty")}</span>
                }

                {
                    shouldShowLinkImage() &&
                    <img className={'img-16 cursor-pointer link-open'}
                         style={{flexShrink: '0', marginTop: '8px', marginRight: '12px', marginLeft: 'auto'}}
                         src={getImagePathWithThemeSvg('link_open')} onClick={async () => {
                        let szUrl = data[key]?.text;
                        if (key == 'infoUrl'){
                            szUrl = data[key];
                        }
                        if (isDeepLink(szUrl)) {
                            window.closeInfo();
                            const deeplink = decodeDeeplink(szUrl);
                            if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                                postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                                    id: deeplink.id,
                                    from: FROM_LIBRARY,
                                    deeplink: deeplink,
                                    selectedId: deeplink.childId,
                                    inSlider: false,
                                })
                            } else {
                                //转到项目
                                const linkInfo: any = await deepLinkToLinkInfo(deeplink);
                                linkInfo.isLink = true;
                                postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {
                                    linkInfo: linkInfo,
                                    inSlider: false
                                });
                            }
                        } else {
                            if (isSupportLink(szUrl)) {
                                ipcInvoke('open-url-withwhen', szUrl)
                            } else {
                                if (!szUrl?.startsWith('http')) {
                                    szUrl = 'https://' + szUrl;
                                }
                                ipcSend('open-url', szUrl)
                            }
                        }
                    }}/>
                }
            </div>
            //endregion
        }
        else if (value?.type == 'rating' || column.type == 'rating') {
            // if (!value.text || value?.text <= 0)return <></>
            return <div className={'flex-row-vertical-center hovered-property-info-item'}
                        style={{
                            height: `${DEFAULT_CONTENT_MIN_HEIGHT}px`,
                            position: 'relative',
                            gap: '0 16px',
                            paddingLeft: '6px',
                            width: '100%'
                        }} onClick={(e)=>{
                e.stopPropagation();
            }}>
                {
                    [...Array(5)].map((p, index) => {
                        return <img className={'img-16 cursor-pointer'}
                                    src={getImagePathWithThemeSvg(`column_rate${index < data[key]?.text ? '_selected' : ''}`)}
                                    onClick={(e) => {
                                        let szInput = index + 1;
                                        const newData = {...data};
                                        const newInputValue = {...newData[key]};
                                        if (newInputValue.text == szInput) {
                                            szInput = 0;
                                        }
                                        newInputValue.type = 'rating';
                                        newInputValue.text = szInput;
                                        newData[key] = newInputValue;
                                        setData(newData);
                                        updateProperty(newData, key);
                                    }}/>
                    })
                }
            </div>
        } else if (isArray(value) || value?.type == 'select' || value?.type == 'multiSelect') {
            if (value.length == 0)return <></>
            if (key == 'tags'){
                return <div className={'hovered-property-info-item'} style={{width: '100%',zIndex:`${MAX_Z_INDEX}`,padding:'0 4px'}}>
                    <CustomPropertyTags item={data} arrayTags={data[key]}/>
                </div>
            }
            return <div className={'hovered-property-info-item'} style={{width: 'calc(100% - 38px)',height:`${DEFAULT_CONTENT_MIN_HEIGHT}px`,zIndex:`${MAX_Z_INDEX}`}}
                        onClick={(e)=>{
                e.stopPropagation();
            }}><CustomPropertySelect
                from={FROM_TAG}
                randomId={Date.now()}
                propertyId={key} selectOptions={data[key]} onSelectChanged={(arraySelectOptions:any)=>{
                const newData = {...data};
                newData[key] = arraySelectOptions;
                setData(newData);
                updateProperty(newData,key);
            }}/></div>
        }else if (value?.type == 'checkbox' || column.type == 'checkbox'){
            return <div style={{paddingLeft:'6px',width:'100%',height:`${DEFAULT_CONTENT_MIN_HEIGHT}px`}} className={'flex-row-vertical-center hovered-property-info-item'} onClick={(e)=>{
                e.stopPropagation();
                const newData = {...data};
                if (newData[key]?.text){
                    newData[key].text = !newData[key].text;
                }else{
                    if (!newData[key]){
                        newData[key] = {};
                    }
                    newData[key].text = true;
                }
                newData[key].type = 'checkbox';
                setData(newData);
                updateProperty(newData,key);
            }}>
                <Checkbox checked={data[key]?.text || false} onChange={e=>{
                    const newData = {...data};
                    newData[key].text = e.target.checked;
                    setData(newData);
                    updateProperty(newData,key);
                }}/>
                <span className={'ml-6'}>{column.name}</span>
            </div>
        }else if (key == 'createTime' || key == 'updateTime') {
            return <div style={{width: '100%', padding: '0 8px', height: `${DEFAULT_CONTENT_MIN_HEIGHT}px`}}
                 className={'flex-row-vertical-center hovered-property-info-item'}>
                {formatDateCharDesc(data[key])}
            </div>
        } else if (value?.type == 'date') {
            if (!value.text)return <></>
            return <div style={{width: '100%'}} className={''} onClick={(e)=>{
                e.stopPropagation();
            }}><Popover arrow={false} align={{}} trigger={['click']}
                                                                        open={openDatePicker[key]}
                                                                        overlayStyle={{zIndex:`${MAX_Z_INDEX}`}}
                                                                       onOpenChange={(e)=>{
                                                                           const newDate:any = {...openDatePicker};
                                                                           newDate[key] = e;
                                                                           setOpenDatePicker(newDate);
                                                                       }}
                                                                       placement={'bottomLeft'}
                                                                       content={<PopupDate defaultDate={(data[key].text)}
                                                                                           width={'334px'}
                                                                                           from={'updateCustomProperty'}
                                                                                           onDateSelect={(longDate, hasClose = true) => {
                                                                                               const newData = {...data};
                                                                                               newData[key].text = longDate;

                                                                                               const newDate = {...openDatePicker};
                                                                                               const arrayKeys = Object.keys(newDate);
                                                                                               for (let i=0;i<arrayKeys.length;i++){
                                                                                                   newDate[arrayKeys[i]] = false;
                                                                                               }
                                                                                               setOpenDatePicker(newDate);

                                                                                               setInputDate(formatDateCharDesc(data[key].text));
                                                                                               updateProperty(newData,key);
                                                                                           }}/>}>
                <div style={{width:'100%',padding:'0 8px',height:`${DEFAULT_CONTENT_MIN_HEIGHT}px`}} className={'flex-row-vertical-center hovered-property-info-item'}>
                    {formatDateCharDesc(data[key].text)}
                    {!data[key].text && <span style={{color:'var(--input-place-holder-color)'}}>{t("Empty")}</span>}
                </div>
            </Popover>
            </div>
        }else if (key == 'type'){
            //类型
            const getTypeName = ()=>{
                let szType = data[key];
                if (szType == 'project'){
                    return t('Project');
                }else if (szType == 'board'){
                    return t('Board')
                }

                if (szType == 'bilibili' || szType == 'baidu' || szType == 'youtube'){
                    szType =  'liveVideo';
                }
                const libraryType = GET_ARRAY_LIBRARY_TYPES().find(p=>p.value == szType);
                if (libraryType){
                    return libraryType.label;
                }
                return '';
            }
            return <div className={'flex-row-vertical-center tableview-column-style'} style={{height:`${DEFAULT_CONTENT_MIN_HEIGHT}px`,marginLeft:'0px'}}>
                <img className={'img-16'} style={{opacity:'0.5'}} src={getImagePathWithTheme(getImageNameFromdeepLinkType(data[key]))}/>
                <span className={'ml-6 span-single-line'}>{getTypeName()}</span>
            </div>
        }
        return <></>
    }

    /**
     * 取标数量
     */
    const getHighlightCount = ()=>{
        if (props.item.data){
            return props.item.data.length;
        }
        return props.item.highlightsCount;
    }

    const getTypeIcon = ()=>{
        // if (props.item.type == 'webLink' && props.item.icon){
        //     return props.item.icon;
        // }
        return getImagePathWithTheme(getLibraryTypeImage(props.item.type));
    }

    const getTitle = ()=>{
        if (props.item.type == 'card'){
            return getCardTitle(props.item);
        }
        return props.item.name || t('Untitled')
    }

    return props.item.id == '-1'?<></>:<div className={'gridview-property-info'} style={{background:'var(--background-color-white)',width:'100%',padding:'0px 8px 0px 8px',height:'100%',borderRadius:'0 0px 8px 8px'}} >
        {
            <div
                 style={{minHeight: `${DEFAULT_CONTENT_MIN_HEIGHT}px`, padding: '8px 8px',display:'flex'}}>
                <img className={'img-15'} style={{opacity:'1.0',marginTop:'3px'}}
                     src={getTypeIcon()}/>
                <span className={'ml-6 font-weight-600 font-family-medium font-size-15 ' + (props.from == FROM_TRASH?'text-truncate-1':'text-truncate')}>{getTitle()}</span>
                {
                    props.item.type == 'journal' &&
                    <span className={'font-family-regular carditem-journal-title'}
                          style={{
                              display: 'block',
                              color: 'var(--primary-color)',
                              marginLeft:'auto',
                              flexShrink:'0',
                              marginTop:'2px'
                          }}>{t(MAP_WEEK_FULL[`${(new Date(props.item.journalTime)).getDay()}`])}</span>
                }

                {
                    (props.item.type == 'videoAnno' || props.item.type == 'audioAnno') &&
                    <span style={{
                        marginLeft: 'auto',
                        color: 'var(--color-666666)',
                        flexShrink:'0',
                        marginTop:'2px'
                    }}>{formatDateHms(props.item.time)}</span>
                }

                {
                    props.from == FROM_HOME_HIGHLIGHT &&
                    <span style={{
                        marginTop:'2px',
                        marginLeft: 'auto',
                        color: 'var(--color-666666)',
                        flexShrink:'0',
                        minWidth:'24px',
                        textAlign:'end',
                    }}>{getHighlightCount()}</span>
                }
            </div>
        }

        {/*视图*/}
        {
            props.tableView &&
            props.tableView.columns.map(p => {
                return <Tooltip arrow={false} open={mapTooltipsOpen[p.id]} onOpenChange={(e)=>{
                    const newMap = {...mapTooltipsOpen};
                    const arrayKeys = Object.keys(newMap);
                    for (let i=0;i<arrayKeys.length;i++) {
                        newMap[arrayKeys[i]] = false;
                    }
                    newMap[p.id] = e;
                    setMapTooltipsOpen(newMap);
                }} title={p.id.length > 30?p.name:t(p.name)} align={{offset:[-8,-2]}} placement={'left'}>
                    {renderContent(p)}
                </Tooltip>;
            })
        }
    </div>
})

export default GridViewPropertyInfo;